"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersQueue = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const alert_1 = require("client/components/ui/alert");
const store_1 = require("client/modules/orders/store");
const store_2 = require("client/modules/patients/store");
const store_3 = require("client/modules/users/store");
const Delete_1 = require("material-ui-icons/Delete");
const Button_1 = require("material-ui/Button");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const moment_1 = require("moment");
const React = require("react");
const react_1 = require("react");
const ReactCSSTransitionGroup = require("react-addons-css-transition-group");
const ReactTooltip = require("react-tooltip");
const errors_1 = require("shared/erx/errors");
const order_1 = require("shared/order");
require("./orders-queue.less");
const throttle_debounce_1 = require("throttle-debounce");
const text_field_small_1 = require("client/components/material/text-field/text-field-small");
// E-069
const columnsTmp = [
    {
        center: false,
        id: "NO_ACTION",
        label: "No.",
        sortable: true,
    },
    {
        center: false,
        id: "site.name",
        label: "Pharmacy",
        numeric: false,
        sortable: true
    },
    {
        center: false,
        id: "patient.lastName",
        label: "Patient Name",
        numeric: false,
        sortable: false
    },
    // {
    //   center: false,
    //   id: "patient.firstName",
    //   numeric: false,
    //   label: "First Name",
    //   sortable: false
    // },
    // {
    //   center: false,
    //   id: "patient.lastName",
    //   numeric: false,
    //   label: "Last Name",
    //   sortable: false
    // },
    {
        center: false,
        id: "NO_ACTION",
        label: "DOB",
        numeric: false,
        sortable: false
    },
    {
        center: true,
        id: "NO_ACTION",
        label: "Gender",
        numeric: false,
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        label: "Zip",
        numeric: false,
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        label: "Appt",
        numeric: false,
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        label: "Insurance",
        numeric: true,
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        label: "Status",
        numeric: true,
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        label: "Cash",
        numeric: true,
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        label: "Expire @",
        numeric: true,
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        label: "",
        numeric: true,
        sortable: false
    }
];
// // E-069
const columns = [
    {
        center: false,
        id: "NO_ACTION",
        label: "No.",
        sortable: true,
    },
    // {
    //   center: false,
    //   id: "site.name",
    //   numeric: false,
    //   label: "Pharmacy",
    //   sortable: true
    // },
    // {
    //   center: false,
    //   id: "patient.firstName",
    //   numeric: false,
    //   label: "First Name",
    //   sortable: false
    // },
    // {
    //   center: false,
    //   id: "patient.lastName",
    //   numeric: false,
    //   label: "Last Name",
    //   sortable: false
    // },
    {
        center: false,
        id: "patient.lastName",
        label: "Patient Name",
        numeric: false,
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        label: "DOB",
        numeric: false,
        sortable: false
    },
    {
        center: true,
        id: "NO_ACTION",
        label: "Gender",
        numeric: false,
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        label: "Zip",
        numeric: false,
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        label: "Appt",
        numeric: false,
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        label: "Insurance",
        numeric: true,
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        label: "Status",
        numeric: true,
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        label: "Cash",
        numeric: true,
        sortable: false
    },
    {
        center: false,
        id: "NO_ACTION",
        label: "",
        numeric: true,
        sortable: false
    }
];
const dummyPatient = {
    address: "",
    address2: "",
    birthDate: new Date(),
    city: "",
    confirmNoInsurance: false,
    email: "",
    firstName: " ",
    gender: "1",
    id: 0,
    insurances: [],
    lastName: " ",
    middleName: "",
    missingInsurance: true,
    notes: "",
    phone: "",
    sites: [],
    state: "",
    uploads: [],
    zip: ""
};
let OrdersQueue = class OrdersQueue extends react_1.Component {
    constructor() {
        super(...arguments);
        this.order = "ASC";
        this.orderBy = "site.name";
        this.patients = [];
        // @observable
        // public checkedBoxes: Set<number> = new Set();
        this.checkedBoxes = new Map();
        this.checks = false;
        this.checkedAll = false;
        this.showDeleteAllQueuesConfirmation = false;
        this.error = "";
        this.loading = false;
        // C-097 Queued Appointments
        this.page = 1;
        this.limit = 100; // C-110
        this.totalPages = 1;
        // public componentWillMount() {
        //   const user = usersStore.user.value;
        //   // ordersStore.readQueue(user.site.id);
        // }
        // C-097 Queued Appointments
        this.loadClaimsQueue = throttle_debounce_1.debounce(200, async () => {
            // C-109
            const viewAllPatients = store_3.usersStore.permissions.ReadPatients;
            let siteId = viewAllPatients ? 0 : "assignedSites";
            this.patients = await store_1.ordersStore.readQueue({
                order: this.order,
                sort: this.orderBy,
                siteId: siteId,
                page: this.page,
                limit: this.limit //For pagination //C-097 queue
            });
            // C-097 Queued Appointments
            this.totalPages = store_1.ordersStore.totalProviderPage;
        });
        this.readQueues = async () => {
            // C-109
            const viewAllPatients = store_3.usersStore.permissions.ReadPatients;
            let siteId = viewAllPatients ? 0 : "assignedSites";
            const query = {
                order: this.order,
                orderBy: this.orderBy,
                siteId: siteId,
                page: this.page,
                limit: this.limit // C-097 Queued Appointments
            };
            this.patients = await store_1.ordersStore.readQueue(query);
            this.totalPages = store_1.ordersStore.totalProviderPage;
            // this.initializeMarkedAsInsuranceCheckBoxes();
        };
        this.initializeMarkedAsInsuranceCheckBoxes = () => {
            for (const submission of this.patients) {
                if (submission.patient && submission.patient.confirmNoInsurance) {
                    this.checkedBoxes.set(submission.id, true);
                }
            }
            this.updateChecks();
        };
        this.handleCheckRow = (submission) => {
            if (this.isValidForSubmission(submission)) {
                this.checkedBoxes.set(submission.id, !this.checkedBoxes.get(submission.id));
            }
            else {
                this.checkedBoxes.set(submission.id, false);
                if (this.checkedAll) {
                    this.checkedAll = false;
                }
            }
            this.updateChecks();
        };
        this.updateChecks = () => {
            this.checks = Array.from(this.checkedBoxes.values()).some((value) => value);
        };
        this.isValidForSubmission = (row) => {
            const pId = row.patient && row.patient.id;
            const pData = mobx_1.toJS(row.patientData) || {};
            /** `updated: boolean` exists when being readded from order. */
            const fixed = pData.hasOwnProperty("updated") ? pData.updated : true;
            const settings = row.site && mobx_1.toJS(row.site.settings);
            const reverseTime = (settings === null || settings === void 0 ? void 0 : settings.autoClaimReverseTime.value) || "10:00 pm";
            const patient = row.patient ? row.patient : pData.patient || null;
            const pFirst = patient.firstName;
            const pLast = patient.lastName;
            const pDOB = patient.birthDate;
            const pGender = patient.gender;
            const pZip = patient.zip;
            const hasId = !!pId;
            const hasFirst = !!pFirst;
            const hasLast = !!pLast;
            const hasDOB = !!pDOB;
            const hasGender = !!pGender;
            const hasZip = !!pZip;
            const hasValidPatientAddress = patient.address || patient.address2;
            const hasInsurance = patient.hasOwnProperty("missingInsurance") && !patient.missingInsurance;
            const insuranceFound = patient.insurances.find((insurance) => insurance.primaryInsurance);
            const markedAsNoInsurance = row.patient && row.patient.confirmNoInsurance;
            const canSubmit = fixed &&
                hasId &&
                hasFirst &&
                hasLast &&
                hasDOB &&
                hasGender &&
                hasZip &&
                hasValidPatientAddress &&
                ((hasInsurance && insuranceFound) || markedAsNoInsurance);
            return canSubmit;
        };
        this.handleCheckAll = () => {
            this.checkedAll = !this.checkedAll;
            if (this.checkedAll) {
                for (const submission of this.patients) {
                    if (this.isValidForSubmission(submission)) {
                        this.checkedBoxes.set(submission.id, true);
                    }
                    else {
                        this.checkedBoxes.set(submission.id, false);
                    }
                }
            }
            else {
                for (const submission of this.patients) {
                    this.checkedBoxes.set(submission.id, false);
                }
            }
            this.updateChecks();
        };
        this.handleDeleteQueue = (submissionId) => async (e) => {
            try {
                this.loading = true;
                e.preventDefault();
                e.stopPropagation();
                const queueToDelete = [submissionId];
                if (queueToDelete.length) {
                    await store_1.ordersStore.deleteQueue(queueToDelete);
                    await this.readQueues();
                }
            }
            catch (err) {
                console.error("Error in deleteing single queue", err);
                this.error = err.code || err.message || "Error in deleting single queue";
            }
            finally {
                this.loading = false;
            }
        };
        this.handleDeleteAllQueues = async () => {
            try {
                this.showDeleteAllQueuesConfirmation = false;
                this.loading = true;
                const queuesToDelete = [];
                this.patients.forEach((submission) => queuesToDelete.push(submission.id));
                if (queuesToDelete.length) {
                    const killWholeQueue = this.siteId === 0;
                    const logData = {
                        action: killWholeQueue
                            ? "Deleted entire queue for all pharmacies."
                            : `Deleted all queued patients for pharmacy ${this.siteId}.`,
                        category: store_3.LogCategory.queue,
                        site: this.siteId,
                        user: store_3.usersStore.user.value.id
                    };
                    await store_1.ordersStore.deleteQueue(queuesToDelete);
                    await store_3.usersStore.createLog(logData);
                    await this.readQueues();
                }
            }
            catch (err) {
                this.error = err.code || err.message || "Error deleting all queueus.";
                console.error("Error in deleting all queues", err);
            }
            finally {
                this.loading = false;
            }
        };
        this.handleSubmit = async () => {
            try {
                this.loading = true;
                const queueToDelete = [];
                for (const [id, isChecked] of this.checkedBoxes) {
                    const submissionId = Number(id);
                    if (isChecked) {
                        const sub = this.patients.find((submission) => submission.id === submissionId);
                        if (sub) {
                            const markedAsNoInsurance = sub.patient.confirmNoInsurance;
                            const { siteId } = sub;
                            const providerId = sub.provider.id;
                            const patientId = sub.patient.id;
                            const insuranceId = markedAsNoInsurance
                                ? null
                                : sub.patient.insurances.find((ins) => ins.primaryInsurance).id;
                            const orderType = markedAsNoInsurance
                                ? order_1.OrderType.Cash
                                : order_1.OrderType.Default;
                            const inventoryIds = [];
                            const runAt = sub.scheduleTime;
                            // console.log("orderType is ", orderType);
                            // console.log("insuraceId", insuranceId);
                            const result = await store_1.ordersStore.createOrder(siteId, providerId, patientId, insuranceId, inventoryIds, orderType, runAt);
                            const logData = {
                                action: `Pushed patient to order list from queue.`,
                                category: store_3.LogCategory.patient,
                                categoryReferenceKey: patientId,
                                order: result ? result.order.id : null,
                                site: siteId,
                                user: store_3.usersStore.user.value.id
                            };
                            await store_3.usersStore.createLog(logData);
                            if (result) {
                                queueToDelete.push(id);
                            }
                        }
                    }
                }
                if (queueToDelete.length) {
                    try {
                        await store_1.ordersStore.deleteQueue(queueToDelete);
                        router_1.RouteManager.transitionTo("/claims");
                    }
                    catch (err) {
                        throw err;
                    }
                    finally {
                        this.loading = false;
                    }
                }
            }
            catch (err) {
                console.error("Error in sending queue to be processed", err);
                this.error =
                    err.code || err.message || "Error in sending queue to be processed";
            }
            finally {
                this.loading = false;
            }
        };
        this.checkCash = async (row, index) => {
            const checkCash = row.patient.confirmNoInsurance;
            if (checkCash) {
                row.patient.confirmNoInsurance = false;
                // Check to see if the patient already has insurance
                if (row.patient.insurances.length > 0) {
                    row.patient.missingInsurance = false;
                }
                else {
                    row.patient.missingInsurance = true;
                }
            }
            else {
                row.patient.confirmNoInsurance = true;
                row.patient.missingInsurance = false;
            }
            // Update the patient in the database and rerender the row
            const result = store_2.patientsStore.savePatient(row.patient);
            if (this.isValidForSubmission(row)) {
                this.checkedBoxes.set(row.id, true);
            }
            else {
                this.checkedBoxes.set(row.id, false);
            }
            this.updateChecks();
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.readQueues();
        };
        // C-097 handle pagination input
        this.handleKeyDown = () => {
            if (this.page === Number(""))
                return;
            (this.page !== store_1.ordersStore.currentPage) && this.loadClaimsQueue();
        };
        this.mapRejectionCodes = (payload) => {
            const rejectionCodes = payload.rejectCode.split(" ");
            rejectionCodes.forEach((code) => {
                const errorProperty = `${code} Error Message`;
                const errorMessage = errors_1.NCPDP_ERROR_CODE_MAP[code];
                payload[errorProperty] = errorMessage;
            });
            return payload;
        };
        this.getRereviewPayloadData = (rawPayload) => {
            const payload = this.mapRejectionCodes(rawPayload);
            function matchRelevance(key) {
                const re = /\d+ Error Message$/g;
                return relavantKeys.includes(key) || key.match(re);
            }
            const relavantKeys = [
                "rejectCode",
                "rejectCount",
                "message",
                "additionalMessage"
            ];
            let htmlString = "<div>";
            if (typeof payload === "object") {
                let patientFullName = "";
                if (payload.patientFirstName && payload.patientLastName) {
                    patientFullName = `${payload.patientFirstName} ${payload.patientLastName}`;
                }
                if (patientFullName) {
                    htmlString += `<p>${patientFullName}</p>`;
                }
                for (const key in payload) {
                    if (payload.hasOwnProperty(key) && matchRelevance(key)) {
                        htmlString += `${key}: ${payload[key]} <br />`;
                    }
                }
            }
            htmlString += "</div>";
            return htmlString;
        };
        this.renderTableRow = (row, index) => {
            var _a, _b;
            const serialNo = index + 1; //E-069
            const pId = row.patient && row.patient.id;
            const pData = (!!row.patientData && mobx_1.toJS(row.patientData)) || {};
            /** `updated: boolean` exists when being readded from order. */
            const fixed = pData.hasOwnProperty("updated") ? pData.updated : true;
            const settings = row.site && mobx_1.toJS(row.site.settings);
            const reverseTime = (settings === null || settings === void 0 ? void 0 : settings.autoClaimReverseTime.value) || "10:00 pm";
            const patient = row.patient ? row.patient : pData.patient;
            const pFirst = patient.firstName;
            const pLast = patient.lastName;
            const pDOB = patient.birthDate;
            const pGender = patient.gender;
            const pZip = patient.zip;
            const hasValidPatientAddress = patient.address || patient.address2;
            const hasId = !!pId;
            const hasSite = !!row.siteId;
            const hasProvider = !!row.providerId;
            const hasFirst = !!pFirst;
            const hasLast = !!pLast;
            const hasDOB = !!pDOB;
            const hasGender = !!pGender;
            const hasZip = !!pZip;
            const hasInsurance = 
            // patient.hasOwnProperty("missingInsurance") && !patient.missingInsurance;
            patient.hasOwnProperty("insurances") && patient.insurances.length;
            const { insurances } = patient;
            const confirmation = patient.confirmNoInsurance;
            const missing = patient.missingInsurance;
            let insurance = "";
            const dobInvalid = hasDOB &&
                (moment_1.utc(pDOB).format("MM/DD/YYYY") === "Invalid date" ||
                    moment(pDOB).isBetween(moment().subtract(30, "days"), moment().add(1000, "years")));
            let primaryInsuranceFound = null;
            if (hasInsurance) {
                primaryInsuranceFound = insurances.find((insurance) => insurance.primaryInsurance);
                if (primaryInsuranceFound) {
                    insurance = primaryInsuranceFound.id;
                }
            }
            else {
                primaryInsuranceFound = insurances.find((insurance) => insurance.primaryInsurance);
                if (primaryInsuranceFound) {
                    insurance = primaryInsuranceFound.id;
                }
            }
            const markedAsNoInsurance = row.patient && row.patient.confirmNoInsurance;
            const aptTime = row.scheduleTime;
            const invalid = React.createElement("span", { style: { color: "red" } }, "Invalid");
            const canSubmit = fixed &&
                hasId &&
                hasSite &&
                hasProvider &&
                hasFirst &&
                hasLast &&
                hasDOB &&
                hasGender &&
                hasZip &&
                hasValidPatientAddress &&
                ((hasInsurance && primaryInsuranceFound) || markedAsNoInsurance);
            const isDuplicate = pData && pData.status === "duplicateInList";
            const hasTimeouts = !!((_a = patient.inventories) === null || _a === void 0 ? void 0 : _a.length);
            // if (isDuplicate) {
            //   console.log("is Duplicate canSubmit is ", canSubmit);
            //   console.log("is Duplicate insurance is ", insurance);
            // }
            const noRxCoverage = pData && pData.status === order_1.SubmissionStatus.NoRxCoverage;
            const lastE1RanAt = noRxCoverage
                ? moment(row.patient.lastErxRequestedAt).format("M/D/YYYY")
                : "";
            const statusText = canSubmit
                ? hasTimeouts
                    ? "Meds on Cooldown"
                    : markedAsNoInsurance
                        ? "Valid (Cash)"
                        : "Valid"
                : !hasSite
                    ? "Missing Pharmacy"
                    : !hasProvider
                        ? "Missing PIC"
                        : !pId
                            ? "Missing Patient"
                            : noRxCoverage && !hasInsurance
                                ? "No Rx Coverage"
                                : confirmation && !missing
                                    ? "No Insurance"
                                    : !fixed
                                        ? "Needs Re-review"
                                        : !hasValidPatientAddress
                                            ? "Missing patient address"
                                            : "Invalid Reqs";
            const insuranceColumnText = confirmation && !missing
                ? "Cash"
                : hasInsurance
                    ? insurance
                    : noRxCoverage
                        ? `Last e1 ran on ${lastE1RanAt}`
                        : invalid;
            let rereviewPayload = "";
            if (row.patientData && row.patientData.payload) {
                rereviewPayload = this.getRereviewPayloadData(row.patientData.payload);
            }
            const isTmp = store_3.usersStore.user.value.user || store_3.usersStore.user.value.siteUser; // C-109.1;
            // E-069 
            return (React.createElement(list_item_1.MaterialListItem, { key: index, className: isDuplicate ? "duplicate-patient-accent" : "", onClick: (e) => this.handleClickRow(row, patient, e) },
                React.createElement("div", { className: "queuedtable-1" },
                    isTmp ? (React.createElement(checkbox_1.MaterialCheckbox, { disabled: !canSubmit, label: "", onAction: () => this.handleCheckRow(row), checked: this.checkedBoxes.has(row.id) && this.checkedBoxes.get(row.id) })) : null,
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: serialNo })),
                isTmp ? (React.createElement(list_item_text_1.MaterialListItemText, { primary: row.site ? (_b = row === null || row === void 0 ? void 0 : row.site) === null || _b === void 0 ? void 0 : _b.displayName : "No site found" })) : null,
                React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(React.Fragment, null,
                        !isTmp ? (React.createElement(checkbox_1.MaterialCheckbox, { disabled: !canSubmit, label: "", onAction: () => this.handleCheckRow(row), checked: this.checkedBoxes.has(row.id) &&
                                this.checkedBoxes.get(row.id) })) : null,
                        (hasFirst && pFirst) || invalid,
                        " ",
                        (hasLast && pLast) || invalid) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: (hasDOB && !dobInvalid && moment_1.utc(pDOB).format("MM/DD/YYYY")) || invalid }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: (hasGender &&
                        (pGender === "1" || pGender.toLowerCase() === "m"
                            ? "M"
                            : pGender === "2" || pGender.toLowerCase() === "f"
                                ? "F"
                                : invalid)) ||
                        invalid }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: (hasZip && pZip !== "00000" && pZip) || invalid }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: moment_1.utc(aptTime).format("MM/DD/YYYY hh:mm A") }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: insuranceColumnText }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement("div", { className: "queues-list__row", "data-tip": rereviewPayload, "data-html": true, "data-for": "rereview" },
                        React.createElement("div", { className: `queues-list__status queues-list__status--${hasTimeouts ? "4pending" : canSubmit ? "3ready" : "1error"}` }),
                        React.createElement("div", { className: "queues-list__status-text" }, statusText || "")) }),
                React.createElement(list_item_text_1.MaterialListItemText, { className: "confirm-cash-list-item", primary: statusText !== "Missing Patient" ? (React.createElement(checkbox_1.MaterialCheckbox, { label: "", value: "confirmNoInsurance", onAction: () => this.checkCash(row, index), checked: row.patient && row.patient.confirmNoInsurance })) : (React.createElement(checkbox_1.MaterialCheckbox, { label: "", "data-tip": "Missing Patient", value: "confirmNoInsurance", disabled: true, checked: false })) }),
                isTmp ? React.createElement(list_item_text_1.MaterialListItemText, { primary: reverseTime }) : null,
                React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement(Button_1.default, { "data-tip": "Delete submission", 
                        // className="remove-btn"
                        style: { minWidth: "0", width: "auto" }, onClick: this.handleDeleteQueue(row.id), color: "default" },
                        React.createElement(Delete_1.default, null)) })));
        };
    }
    async componentDidMount() {
        await this.readQueues();
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    async handleClickRow(row, patient, e) {
        if (e.target.type === "checkbox")
            return;
        const pId = (row.patient && row.patient.id) || 0;
        const pFirst = row.patient && row.patient.firstName;
        const pLast = row.patient && row.patient.lastName;
        const pDob = row.patient && row.patient.birthDate;
        const pGender = row.patient && row.patient.gender;
        const pZip = row.patient && row.patient.zip;
        const pIns = row.patient && row.patient.ins;
        let path = `/patients/${pId}?queue=true&row=${row.id}`;
        if (pId !== 0 && pFirst && pLast && pDob && pGender && pZip && !pIns) {
            path += `&showcf=false`;
        }
        router_1.RouteManager.transitionTo(path);
        // &showcf=false
    }
    render() {
        const user = store_3.usersStore.user.value;
        const site = user === null || user === void 0 ? void 0 : user.site;
        const settings = site && mobx_1.toJS(site.settings);
        const reverseTime = settings === null || settings === void 0 ? void 0 : settings.autoClaimReverseTime;
        const timeString = reverseTime === null || reverseTime === void 0 ? void 0 : reverseTime.value;
        return (React.createElement("div", { className: "queue queue-tableheader ordersQue-wrapper" },
            store_3.usersStore.permissions.ReadQueue ? (React.createElement(React.Fragment, null,
                React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                    React.createElement("div", { className: "queue__title-wrapper" },
                        React.createElement(kpi_title_1.KpiTitle, { label: "Queued Appointments", subLabel: "Click to Edit Patients", subLabel2: this.siteId !== 0 &&
                                `Queue Wiped Daily at ${timeString !== null && timeString !== void 0 ? timeString : "10:00 pm"}` }))),
                React.createElement(floating_page_1.FloatingPage, null,
                    React.createElement(ReactCSSTransitionGroup, { transitionName: "error", transitionEnterTimeout: 500, transitionLeaveTimeout: 500 }, this.error && (React.createElement(alert_1.UiAlert, { dismissable: true, onRequestDismiss: () => (this.error = ""), title: "Error", type: "error", message: this.error }))),
                    this.renderMain(),
                    React.createElement("div", { className: "pagination-container-header" },
                        React.createElement("button", { className: "btn-pagination", onClick: () => {
                                if (this.page === 1)
                                    return;
                                this.page--;
                                this.loadClaimsQueue();
                            } }, "Previous"),
                        React.createElement("div", { className: "pagination-container" },
                            React.createElement("p", null, "Page"),
                            React.createElement("div", { style: { display: 'contents' } },
                                React.createElement("div", { className: "cstmPaginationInput-Wrapper" },
                                    React.createElement(text_field_small_1.MaterialTextFieldSmall, { className: "pagination-input", autoFocus: true, type: "text", onChange: (e) => {
                                            const value = Number(e.target.value);
                                            if (value >= 1 && value <= store_1.ordersStore.totalProviderPage) {
                                                this.page = value;
                                            }
                                            else {
                                                if (e.target.value <= store_1.ordersStore.totalProviderPage) {
                                                    this.page = value;
                                                }
                                                else {
                                                    e.target.value = this.page;
                                                }
                                            }
                                        }, onKeyDown: () => { }, onKeyDownEnterPress: this.handleKeyDown, value: this.page || "" })),
                                React.createElement("div", null, "of"),
                                React.createElement("div", null, this.totalPages)),
                            React.createElement("select", { className: "pagination-input", onChange: (e) => {
                                    this.limit = Number(e.target.value);
                                    this.page = 1;
                                    this.loadClaimsQueue();
                                }, defaultValue: this.limit },
                                React.createElement("option", { value: "5" }, "5 rows"),
                                React.createElement("option", { value: "10" }, "10 rows"),
                                React.createElement("option", { value: "25" }, "25 rows"),
                                React.createElement("option", { value: "50" }, "50 rows"),
                                React.createElement("option", { value: "100" }, "100 rows"))),
                        React.createElement("button", { className: "btn-pagination1", onClick: () => {
                                if (store_1.ordersStore.claimsLoading && this.page === this.totalPages)
                                    return;
                                this.page++;
                                this.loadClaimsQueue();
                            }, disabled: this.page === this.totalPages }, "Next"))))) : (store_3.usersStore.showLock()),
            React.createElement(ReactTooltip, { effect: "solid", place: "left" }),
            React.createElement(ReactTooltip, { id: "rereview", effect: "solid", place: "left" }),
            this.showDeleteAllQueuesConfirmation ? (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Delete all queues", cancelText: "Cancel", message: `Deleting all queues confirmation. Proceeding will delete all submission queues. `, onCancel: () => (this.showDeleteAllQueuesConfirmation = false), onConfirm: this.handleDeleteAllQueues, title: "Delete all queues confirmation" })) : null));
    }
    renderMain() {
        // If you found yourself here looking at a dissappearing column,
        // this magic number needs to be changed because the push function
        // was being invoked twice.
        const isTmp = store_3.usersStore.user.value.user || store_3.usersStore.user.value.siteUser; // C-109.1;
        console.log("this.patient ----", this.patients);
        return (React.createElement(ui_1.UiForm, { loading: this.loading },
            React.createElement("div", { className: "queue__main" },
                React.createElement("div", { className: "queue__main--delete-all-queue-container" },
                    React.createElement(button_1.MaterialButton, { flat: true, onClick: () => (this.showDeleteAllQueuesConfirmation = true) }, "Delete all queues")),
                React.createElement("div", { className: "queue__data" },
                    React.createElement("div", { className: "queue__list" },
                        React.createElement(list_1.MaterialList
                        // noMargin
                        , { 
                            // noMargin
                            onRequestSort: this.onRequestSort, checkbox: this.renderCheckAll(), columns: isTmp ? columnsTmp : columns, order: this.order, orderBy: this.orderBy, rows: this.patients || [], 
                            // rows={[]}
                            renderRow: this.renderTableRow, 
                            // queueListCustom={isTmp}
                            resizableheader: true, customClass: `custom-material-list__order-queue-list${isTmp ? "--tmp" : ""}` })),
                    React.createElement("div", { className: "queue-process-btn" },
                        React.createElement(button_1.MaterialButton, { className: "queue__submit", disabled: !this.checks, primary: true, onClick: this.handleSubmit }, "Send to Claim Processing")),
                    React.createElement(ReactTooltip, { effect: "solid", place: "left" })))));
    }
    renderCheckAll() {
        return (React.createElement(checkbox_1.MaterialCheckbox, { onAction: this.handleCheckAll, label: "", checked: this.checkedAll }));
    }
};
__decorate([
    mobx_1.observable
], OrdersQueue.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], OrdersQueue.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], OrdersQueue.prototype, "patients", void 0);
__decorate([
    mobx_1.observable
], OrdersQueue.prototype, "checkedBoxes", void 0);
__decorate([
    mobx_1.observable
], OrdersQueue.prototype, "checks", void 0);
__decorate([
    mobx_1.observable
], OrdersQueue.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], OrdersQueue.prototype, "checkedAll", void 0);
__decorate([
    mobx_1.observable
], OrdersQueue.prototype, "showDeleteAllQueuesConfirmation", void 0);
__decorate([
    mobx_1.observable
], OrdersQueue.prototype, "error", void 0);
__decorate([
    mobx_1.observable
], OrdersQueue.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], OrdersQueue.prototype, "page", void 0);
__decorate([
    mobx_1.observable
], OrdersQueue.prototype, "limit", void 0);
__decorate([
    mobx_1.observable
], OrdersQueue.prototype, "totalPages", void 0);
OrdersQueue = __decorate([
    mobx_react_1.observer
], OrdersQueue);
exports.OrdersQueue = OrdersQueue;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-queue/orders-queue.tsx
// module id = 3768
// module chunks = 0